import config from 'const/config'
import { PAYSOL } from 'const/account/clients'

export const handleMakeAPaymentOffline = () => {
  const clientName = localStorage.getItem('client')

  const baseURL = new URL(`${config.DTP_HOST_NAME}/accountlookup`)
  const params =
    clientName === PAYSOL
      ? { lob: 'pscc', client: 'paysol' }
      : { lob: 'rc', client: clientName }

  const queryParams = new URLSearchParams(params).toString()
  const redirectURL = `${baseURL.href}?${queryParams}`

  window.open(redirectURL, '_blank', 'noopener,noreferrer')
}
